import { Seller } from "types";
import { queryClient } from "../api/queryClient";
import { useAccountStore } from "../stores/accountStore";

/**
 * Return the seller from the store without going through the `useAccountStore` hook.
 * ** THIS SHOULD BE USED RARELY **
 * Needing this most likely indicates a problem in your code architecture, so re-think that first
 */
export const getSeller = () => {
    const { seller: sellerId } = useAccountStore.getState();
    return queryClient.getQueryData<Seller>(["sellers", sellerId])!;
};
